import { usePool, useSaleTimeline } from '@trustpad/launchpad';

import * as React from 'react';

import { DateTimeFormat } from '~config/constants';

const Td = ({ children }) => <td className="pr-6 pb-2 pl-0">{children}</td>;

export function SaleTimeline({
  showRegistration,
}: {
  showRegistration: boolean;
}) {
  const { isLoading } = usePool();
  const { start, end, registerStart, registerEnd, fcfsStart } =
    useSaleTimeline();
  const format = DateTimeFormat.noYear.replace(' UTC', '');
  const endFormat =
    start && end && start.day() === end.day()
      ? DateTimeFormat.time.replace(' UTC', '')
      : format;

  if (isLoading) {
    return null;
  }

  return (
    <table className="text-sm">
      <tbody className="">
        {registerStart && showRegistration && (
          <tr>
            <Td>📝 Register</Td>
            <Td>
              {registerStart.format(format)} – {registerEnd.format(format)} UTC
            </Td>
          </tr>
        )}
        <tr>
          <Td>💰 Sale</Td>
          <Td>
            {start ? (
              <div>
                {start.format(format)} – {end ? end.format(endFormat) : 'TBA'}{' '}
                UTC
              </div>
            ) : (
              <div>TBA</div>
            )}
          </Td>
        </tr>
        {fcfsStart ? (
          <tr>
            <Td>🏃‍♂ FCFS</Td>
            <Td>{fcfsStart.format(format)} UTC</Td>
          </tr>
        ) : null}
      </tbody>
    </table>
  );
}
